import { inrFull } from "@/lib/format";

export const toP = (x) => Math.max(0, Math.round((Number(x) || 0) * 100));

// Cash lines hold the amount tendered; only what the bill needs is applied, the rest is change.
export function cashBreakdown(payments, total) {
  const totalP = toP(total);
  const nonCashP = payments.filter((p) => p.method !== "cash").reduce((s, p) => s + toP(p.amount), 0);
  let dueP = Math.max(0, totalP - nonCashP);
  let recvP = 0, appliedP = 0;
  const lines = payments.map((p) => {
    if (p.method !== "cash") return { method: p.method, applied: toP(p.amount) / 100 };
    const r = toP(p.amount), a = Math.min(r, dueP);
    dueP -= a; recvP += r; appliedP += a;
    return { method: "cash", applied: a / 100, received: r / 100 };
  });
  const appliedTotalP = nonCashP + appliedP;
  return { lines, hasCash: recvP > 0, received: recvP / 100, change: (recvP - appliedP) / 100, cashApplied: appliedP / 100,
    applied: appliedTotalP / 100, balance: Math.max(0, totalP - appliedTotalP) / 100 };
}

function R({ label, v, tid, cls = "text-slate-700" }) {
  return <div className={`flex justify-between ${cls}`}><span>{label}</span><span className="tabular font-semibold" data-testid={tid}>{inrFull(v)}</span></div>;
}

export function CashChange({ cash, total, billLabel = "Bill Amount", prefix = "pos-cash" }) {
  if (!cash.hasCash || cash.applied > Number(total) + 0.01) return null;
  return (
    <div className="mt-2 space-y-1 rounded-lg bg-slate-50 p-2.5 text-xs" data-testid={`${prefix}-change`}>
      <R label={billLabel} v={total} tid={`${prefix}-bill`} />
      <R label="Cash Received" v={cash.received} tid={`${prefix}-received`} />
      <R label="Change to Return" v={cash.change} tid={`${prefix}-change-amount`} cls={cash.change > 0 ? "text-emerald-700 text-sm" : "text-slate-700"} />
      {cash.balance > 0 && <R label="Remaining Balance" v={cash.balance} tid={`${prefix}-remaining`} cls="text-amber-700" />}
    </div>
  );
}
